import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const LABELS = {
  "": "Home",
  about: "About Us",
  services: "Services",
  contact: "Contact Us",
};

/**
 * Breadcrumbs that sit ABOVE a page hero with a dark background image.
 * Always uses light text for readability on dark/photo backgrounds.
 */
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  const parts = pathname.split("/").filter(Boolean);
  const crumbs = [{ label: "Home", to: "/" }];
  let acc = "";
  parts.forEach((p) => {
    acc += `/${p}`;
    crumbs.push({ label: LABELS[p] || p, to: acc });
  });

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="relative z-10 pt-32 md:pt-40 pb-2 md:pb-4"
    >
      <ol className="flex items-center gap-2 flex-wrap text-[11px] tracking-[0.28em] uppercase">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={c.to} className="flex items-center gap-2">
              {i === 0 && <Home size={12} style={{ color: "var(--gicp-gold)" }} />}
              {last ? (
                <span style={{ color: "var(--gicp-gold)" }}>{c.label}</span>
              ) : (
                <Link
                  to={c.to}
                  className="transition-colors hover:text-[var(--gicp-gold)]"
                  style={{ color: "rgba(253,251,247,0.78)" }}
                  data-testid={`breadcrumb-${c.label.toLowerCase()}`}
                >
                  {c.label}
                </Link>
              )}
              {!last && (
                <ChevronRight size={12} style={{ color: "rgba(253,251,247,0.45)" }} />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
